<template>
  <v-app>
    <sidebar-layout></sidebar-layout>
    <header-layout :class="homepage ? 'header--homepage' : ''" v-if="!useMobileParam" />
    <div class="header--height" v-if="!useMobileParam"></div>
    <!--    <div :style="{ height: !useMobileParam ? headerHeight + 'px' : 0 }"></div>-->
    <breadcrumb :breadcrumbs="breadcrumbs" />
    <slot />
    <footer-layout v-if="useFooter && $route.query.mobile !== 'true'" />
    <agen-naik-kelas-progress v-if="!useMobileParam && loggedIn && !isAgenNaikKelasPage" />
    <agen-naik-kelas-progress-modal />
    <agen-naik-kelas-history-modal />
    <agent-notes-modal />
    <modal-login></modal-login>
    <modal-register></modal-register>
    <modal-forget-pass></modal-forget-pass>
    <modal-forget-pass-confirm></modal-forget-pass-confirm>
    <modal-phone></modal-phone>
    <activate-listing-modal></activate-listing-modal>
    <repost-listing-modal />
    <bulk-repost-listing-modal />
    <schedule-repost-listing-modal />
    <recommended-listing-modal />
    <change-recommended-modal />
    <modal-takeover></modal-takeover>
    <buy-featured-agent-modal />
    <transfer-coin-modal />
    <client-only>
      <validation-handler />
    </client-only>
  </v-app>
</template>

<script>
import Breadcrumb from '@/components/layouts/partials/breadcrumb';
const ValidationHandler = () => import('@/components/utils/validation-handler');
const HeaderLayout = () => import('@/components/layouts/header-layout');
const FooterLayout = () => import('@/components/layouts/footer-layout');
const SidebarLayout = () => import('@/components/layouts/sidebar');
const ModalLogin = () => import('@/components/auth/modals/modal-login');
const ModalRegister = () => import('@/components/auth/modals/modal-register');
const ModalForgetPass = () => import('@/components/auth/modals/modal-forget-pass');
const ModalForgetPassConfirm = () => import('@/components/auth/modals/modal-forget-pass-confirm');
const ModalPhone = () => import('@/components/auth/modals/modal-phone');
import { mapState } from 'vuex';
const ActivateListingModal = () => import('@/components/coins-usage/modals/activate-listing-modal');
const RepostListingModal = () => import('@/components/coins-usage/modals/repost-listing-modal');
const BulkRepostListingModal = () =>
  import('@/components/coins-usage/modals/bulk-repost-listing-modal');
const ScheduleRepostListingModal = () =>
  import('@/components/coins-usage/modals/schedule-repost-listing-modal');
const RecommendedListingModal = () =>
  import('@/components/coins-usage/modals/recommended-listing-modal');
const ChangeRecommendedModal = () =>
  import('@/components/coins-usage/modals/change-recommended-modal');
const ModalTakeover = () => import('@/components/home/modals/modal-takeover');
const BuyFeaturedAgentModal = () =>
  import('@/components/coins-usage/modals/buy-featured-agent-modal');
import tawkto from '@/mixins/tawkto.js';
import TransferCoinModal from '@/components/coins-usage/modals/transfer-coin-modal.vue';
import AgenNaikKelasProgress from '@/components/utils/agen-naik-kelas-progress.vue';
import AgenNaikKelasProgressModal from '@/components/utils/modals/agen-naik-kelas-progress-modal.vue';
import AgenNaikKelasHistoryModal from '@/components/utils/modals/agen-naik-kelas-history-modal.vue';
import AgentNotesModal from '@/components/listing/modals/agent-notes-modal.vue';
export default {
  mixins: [tawkto],
  head() {
    return this.head;
  },
  created() {},
  components: {
    TransferCoinModal,
    Breadcrumb,
    HeaderLayout,
    FooterLayout,
    SidebarLayout,
    ValidationHandler,
    ModalLogin,
    ModalRegister,
    ModalForgetPass,
    ModalForgetPassConfirm,
    ModalPhone,
    ActivateListingModal,
    RepostListingModal,
    BulkRepostListingModal,
    ScheduleRepostListingModal,
    ModalTakeover,
    BuyFeaturedAgentModal,
    RecommendedListingModal,
    ChangeRecommendedModal,
    AgenNaikKelasProgress,
    AgenNaikKelasProgressModal,
    AgenNaikKelasHistoryModal,
    AgentNotesModal,
  },
  computed: {
    useMobileParam() {
      return this.$route.query.mobile === 'true';
    },
    isAgenNaikKelasPage() {
      return this.$route.name === 'agen-naik-kelas';
    },
    headerHeight() {
      return this.$store.getters['global/getHeaderHeight']();
    },
    ...mapState({
      head: (state) => state.head.content,
      loggedIn: (state) => state.global.loggedIn,
    }),
  },
  props: {
    homepage: {
      type: Boolean,
      default: false,
    },
    useFooter: {
      type: Boolean,
      default: true,
    },
    breadcrumbs: { type: Array, default: () => null },
  },
  async mounted() {
    await this.$store.dispatch('global/fetch');
  },
};
</script>
